<template>
  <div>
    <ul v-if="bulletList" :class="$style.unorderedList" v-bind="$attrs">
      <slot />
    </ul>
    <ol v-if="!bulletList" :class="$style.orderedList" v-bind="$attrs">
      <slot />
    </ol>
  </div>
</template>

<script setup lang="ts">

interface ListProps {
  bulletList?: boolean
  items?: []
}

const { bulletList = true } = defineProps<ListProps>()
</script>

<style module>

.unorderedList {
  margin: 0;
  * + & {
    margin-top: 25px;
  }
}

.orderedList {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: item;
}
</style>
